import {$$} from '@vue-macros/reactivity-transform/macros'
import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'
import {
  IButtonPropertyOptions,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/ButtonPropertyTypeStrategy/types/IButtonPropertyTypeInterfaces'
import {PropertyStrategyComponentType} from '@toolify/client/src/modules/tableItems/enum/PropertyStrategyComponentType'
import {
  getButtonPropertyPresentation,
} from '@toolify/client/src/modules/databases/functions/getButtonPropertyPresentation'
import {
  ButtonActionType,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/ButtonPropertyTypeStrategy/enum/ButtonActionType'
import {
  IButtonActionPayloadMap,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/ButtonPropertyTypeStrategy/types/IButtonActionPayloadMap'
import {getFilterReferences} from '@toolify/server/src/services/FilterService/utils/getFilterReferences'
import {
  BUTTON_URL_RECORD_ID_VARIABLE_KEY,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/ButtonPropertyTypeStrategy/constants/ButtonUrlRecordIdVariableKey'
import {getFormulaVariableKeys} from '@toolify/server/src/services/FormulaService/utils/resolveFormulaVariableTemplate'

export function useButtonValueTypeStrategy() {
  const strategyComponentType = PropertyStrategyComponentType.Other

  const fullValueToText = (_value: null, property: IDatabasePropertyResponseInstance) => {
    return getButtonPropertyPresentation(
      property?.options as IButtonPropertyOptions | null,
      property?.title,
    ).label
  }

  const canGroupByView = () => false

  const compareItemValues = () => 0

  // The enabled filter and the URL formula read columns the view may hide, so they are fetched with the rows
  const getAdditionalPropertyIdsToFetch = (property: IDatabasePropertyResponseInstance): string[] => {
    const options = property?.options as IButtonPropertyOptions | null
    const propertyIds = getFilterReferences(options?.enabledFilter).propertyIds
    if(options?.actionType === ButtonActionType.OpenUrl) {
      const url = (options.actionPayload as IButtonActionPayloadMap[ButtonActionType.OpenUrl] | null)?.url
      getFormulaVariableKeys(url)
        .filter(key => key !== BUTTON_URL_RECORD_ID_VARIABLE_KEY)
        .forEach(propertyId => propertyIds.add(propertyId))
    }
    return Array.from(propertyIds)
  }

  return $$({
    fullValueToText,
    strategyComponentType,
    canGroupByView,
    compareItemValues,
    getAdditionalPropertyIdsToFetch,
  })
}
